import type { TefComs4p } from '@mfe/components/TefComs4p';
import { consentStore } from '@mfe/store';
import { Purpose } from '@mfec/types/model';
import { html, nothing } from 'lit';

//
// renders the main component view in VIEW mode
//
export const tefComs4pView = function render(this: TefComs4p)
  : ReturnType<typeof html> {
  return html`
    <div class="container" data-testid="root">
      <section cloak=${this.cloak || nothing}>
        <h4 class="typography-display--4">Partner-APP Einstellungen</h4>
        <p>
          Im Folgenden können Sie für jede Partner-APP den Verarbeitungen personenbezogener Daten auf Grundlage gesetzlicher Bestimmungen widersprechen und Ihre ggf. erteilten Einwilligungen sehen. 
        </p>
        <p>
          Nähere Informationen zu den Partner-Services und Verarbeitungszwecken finden Sie auf unserer Seite.
        </p>
        <p>
          <a href="https://www.telefonica.de/unternehmen/datenschutz/partner-services.html">Partner Services I Telefonica Deutschland (telefonica.de)</a>
        </p>
        ${consentStore.actualConsents.map((purpose : Purpose) => this.getTemplateFn('singlePurposeView')(purpose))}
      </section>
      <tef-coms-back-button text="Zurück"></tef-coms-back-button>
    </div>
    `;
};
